import { fallbackFlags } from 'config/launch-darkly-config';
import {
  setIsLoading,
  setError,
  setSuccess
} from 'state/analytics/analytics-slice';
import { getAdobeTargetOffer } from 'api/adobe-target';

import type { Dispatch } from '@reduxjs/toolkit';

export type TExperimentFlag = keyof typeof fallbackFlags;

export const getAdobeTargetOfferThunk = (
  experimentName: TExperimentFlag
) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading({ experimentName }));
    const response = await getAdobeTargetOffer(experimentName);
    const experimentValue = response?.[0]?.content?.[0]?.variation;
    const parsedExperimentValue = experimentValue
      ? JSON.parse(experimentValue)
      : experimentValue;

    dispatch(
      setSuccess({ experimentName, experimentValue: parsedExperimentValue })
    );

    return Promise.resolve(response);
  } catch (error) {
    dispatch(setError({ experimentName, error }));

    return Promise.reject(error);
  }
};
